'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reauthorize = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _timeout = require('q/js/lib/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _defaults = require('../constants/defaults');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reauthorize = exports.reauthorize = function reauthorize(auth) {
  return (0, _timeout2.default)(new _q2.default.Promise(function (resolve, reject) {
    auth.authorize(null, null, function (error) {
      if (error) {
        reject(error);
      }

      resolve();
    });
  }), _defaults.PROMISE_TIMEOUT_MS, 'PubSub reauthorization timeout');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/reauthorize.js
// module id = 785
// module chunks = 2 3